"use client"; // For use with Next.js App Router

import React, { useEffect, useCallback, useState, SetStateAction, Dispatch } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { Box, Button, Card, CardActionArea, Chip, Fade, Icon, Typography } from "@mui/material";
import Arrow2LeftIcon from "@/app/_components/Icons/Arrow2LeftIcon";
import Arrow2RightIcon from "@/app/_components/Icons/Arrow2RightIcon";
import { theme } from "../../../Providers/theme";
import DOMPurify from "isomorphic-dompurify";
import NextLink from "next/link";
import { usePrevNextButtons } from "@/lib/usePrevNextButtons";
import { ItemType } from "./CategoriesSlider";
import {} from "@reduxjs/toolkit";

const CategoriesSliderChips = ({
  items,
  cat,
  setCat,
}: {
  items?: ItemType[];
  cat?: ItemType | null;
  setCat?: Dispatch<SetStateAction<ItemType | null>>;
}) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: false, direction: "rtl", dragFree: true });
  // @ts-ignore
  const { nextBtnDisabled, onNextButtonClick, onPrevButtonClick, prevBtnDisabled } = usePrevNextButtons(emblaApi);
  // useEffect(() => {
  //   if (emblaApi) {
  //     // Embla API is ready
  //   }
  // }, [emblaApi]);
  if (!items || items.length <= 0) {
    return <></>;
  }
  return (
    // embla
    <Box sx={{ py: 0.5, position: "relative", width: "100%" }}>
      {/*  embla__viewport */}
      <Box sx={{ overflow: "hidden", position: "relative" }} ref={emblaRef}>
        {/* embla__container */}
        <Box sx={{ display: "flex", gap: { xs: 1, md: 2 } }}>
          {items &&
            items.map((slide, index) => {
              {
                /* embla__slide */
              }
              return (
                <Chip
                  key={index}
                  label={slide.title}
                  color="primary"
                  variant={cat?.id === slide.id ? "filled" : "outlined"}
                  onClick={() => {
                    setCat && setCat(slide);
                  }}
                />
              );
            })}
        </Box>
      </Box>
      <Fade in={!nextBtnDisabled}>
        <Box
          sx={(theme) => ({
            position: "absolute",
            display: "flex",
            alignItems: "center",
            right: 0,
            top: 0,
            height: "100%",
            width: "25px",
            zIndex: 1,
            background: `linear-gradient(90deg,  ${theme.palette.background.default},transparent)`,
          })}
        ></Box>
      </Fade>
      <Fade in={!prevBtnDisabled}>
        <Box
          sx={(theme) => ({
            position: "absolute",
            display: "flex",
            alignItems: "center",
            left: 0,
            top: 0,
            height: "100%",
            width: "25px",
            zIndex: 1,
            background: `linear-gradient(90deg, transparent,  ${theme.palette.background.default})`,
          })}
        ></Box>
      </Fade>
    </Box>
  );
};

function arePropsEqual<P>(prevProps: Readonly<P>, nextProps: Readonly<P>): boolean {
  return JSON.stringify(prevProps) === JSON.stringify(nextProps);
}

export default React.memo(CategoriesSliderChips, arePropsEqual);
